import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  Renderer2,
  SimpleChanges,
  AfterViewInit,
  OnChanges,
} from '@angular/core';

/**
 * Marca el ancestro `.tm-hover-cell` con `tm-is-truncated` solo si el texto
 * está realmente cortado con ellipsis (scrollWidth > clientWidth).
 * Así la expansión al hover y el title nativo solo aplican cuando hay truncado.
 * (Mismo criterio que el modal de movimientos de máquinas, columna destino).
 */
@Directive({
  selector: '[tmMarkIfTruncated]',
})
export class TmMarkIfTruncatedDirective implements AfterViewInit, OnChanges, OnDestroy {
  @Input('tmMarkIfTruncated') sourceText: string | number | null | undefined;

  private readonly onResize = () => this.scheduleCheck();

  constructor(private el: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngAfterViewInit() {
    window.addEventListener('resize', this.onResize);
    this.scheduleCheck();
    setTimeout(() => this.check(), 0);
    setTimeout(() => this.check(), 150);
  }

  ngOnChanges(_: SimpleChanges) {
    this.scheduleCheck();
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.onResize);
  }

  private scheduleCheck() {
    requestAnimationFrame(() => this.check());
  }

  private check() {
    const el = this.el.nativeElement;
    const cell = el.closest('.tm-hover-cell');
    if (!cell) {
      return;
    }

    const hasContent =
      this.sourceText != null && String(this.sourceText).trim().length > 0;
    if (!hasContent) {
      this.renderer.removeClass(cell, 'tm-is-truncated');
      this.renderer.removeAttribute(el, 'title');
      return;
    }

    if (el.clientWidth < 1) {
      return;
    }

    const truncated = el.scrollWidth > el.clientWidth + 1;
    if (truncated) {
      this.renderer.addClass(cell, 'tm-is-truncated');
      this.renderer.setAttribute(el, 'title', String(this.sourceText));
    } else {
      this.renderer.removeClass(cell, 'tm-is-truncated');
      this.renderer.removeAttribute(el, 'title');
    }
  }
}
